import { create } from "zustand";
import { persist } from "zustand/middleware";

export const usePinnedState = create(
  persist(
    (set) => ({
      isPinned: false,
      togglePinned: () => set((state) => ({ isPinned: !state.isPinned })),
    }),
    { name: "sidebar-storage" },
  ),
);

export const useSidebarContextStore = create(
  persist(
    (set, get) => ({
      lastReportByKey: {},
      scrollTopByMode: {},
      setLastReport: (buildingId, reportType, location) =>
        set((state) => ({
          lastReportByKey: {
            ...state.lastReportByKey,
            [`${buildingId}:${reportType}`]: location,
          },
        })),
      getLastReport: (buildingId, reportType) =>
        get().lastReportByKey[`${buildingId}:${reportType}`] || null,
      setScrollTop: (mode, value) =>
        set((state) => ({ scrollTopByMode: { ...state.scrollTopByMode, [mode]: value } })),
      getScrollTop: (mode) => get().scrollTopByMode[mode] || 0,
    }),
    {
      name: "sidebar-context",
      partialize: (state) => ({ lastReportByKey: state.lastReportByKey }),
    },
  ),
);
